import { NgModule } from '@angular/core';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzNotificationModule } from 'ng-zorro-antd/notification';
import { NzConfig, NZ_CONFIG } from 'ng-zorro-antd/core/config';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzCalendarModule } from 'ng-zorro-antd/calendar';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';

const ngZorroConfig: NzConfig = {
  notification: { nzPlacement: 'bottomLeft', nzDuration: 4000 },
};

@NgModule({
  providers: [{ provide: NZ_CONFIG, useValue: ngZorroConfig }],
  exports: [
    NzSelectModule,
    NzCheckboxModule,
    NzModalModule,
    NzNotificationModule,
    NzInputModule,
    NzFormModule,
    NzCollapseModule,
    NzAvatarModule,
    NzRadioModule,
    NzCalendarModule,
    NzDrawerModule,
  ],
})
export class NgZorroAntdModule {}
